module.exports = __webpack_public_path__ + "img/null-comment.3af0928d.svg";